import { GET_SUB_D_ASSORTMENT } from '../API';

const query = {
  getSubDAssortmentDetails: GET_SUB_D_ASSORTMENT,
};

export { query };
